import { useEffect, useState } from 'react';
import { fetchVideos } from '../store';

export const useVideoFeed = (enabled = true) => {
  const [feed, setFeed] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!enabled) return undefined;
    const controller = new AbortController();
    let loading = false;
    const refresh = async () => {
      if (loading || controller.signal.aborted) return;
      loading = true;
      const data = await fetchVideos(controller.signal);
      if (!controller.signal.aborted) {
        if (data) { setFeed(data); setError(''); }
        else setError('Unable to refresh videos. Retrying automatically.');
      }
      loading = false;
    };
    const onVisible = () => { if (!document.hidden) refresh(); };
    refresh();
    const timer = setInterval(onVisible, 60000);
    window.addEventListener('focus', onVisible);
    window.addEventListener('gv-videos-updated', refresh);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      controller.abort(); clearInterval(timer);
      window.removeEventListener('focus', onVisible);
      window.removeEventListener('gv-videos-updated', refresh);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled]);
  return { feed, error };
};